
import {Component, Vue} from "vue-property-decorator";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import {getPageAPIs, Util} from "@/common/util";
import OperationRecordAPI from "@/common/api/operationRecord";

export const pageApiList = getPageAPIs(OperationRecordAPI);


const defaultForm: any = {
  account: '',
  time: []
}

@Component({})
export default class OperationRecord extends Vue {
  private operationRecordApi: any = new OperationRecordAPI();
  private deepLoopUtil: any;
  private form: any = {};

  constructor() {
    super();
    this.deepLoopUtil = new DeepLoop();

    this.form = this.deepLoopUtil.deepCopy(defaultForm);
  }
  // private visible: boolean = false;
  // private forms: any = {
  //   nickname: 0,
  //   account:'',
  //   password: "",
  //   department_id:null
  // };
  // private operateType:string = 'add'
  private departmentList:any = []

  private activated(): void {
    this.getTable();
  }

  private getOperationRecordParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const {
      account,
      time, // 时间
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {

    };
    // if (shop_name) {
    //   outerParams.shop_name = shop_name;
    // }

    if (account) {
      outerParams.account = account;
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      outerParams.start_date = startTime;

      outerParams.end_date = endTime;
    }

    if (
      mode == "exportExcel" &&
      !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  private getTable(): void {
    const params = this.getOperationRecordParams()
    this.operationRecordApi.getOperationRecord(
        {
          ...params,
        },
        (res: any) => {
          this.tableData = res.data.list;
          this.tablePage.totalCount = res.data.count;
          this.tablePage.pageNo = res.data.page;
          this.tablePage.pageSize = res.data.prepage;
        }
    );
  }

  // private getDepartmentList(){
  //   this.operationRecordApi.getDepartmentList({
  //     page: 1,
  //     limit: 200,
  //   },(res:any)=>{
  //     this.departmentList = res.data.list
  //   })
  // }


  // private adduser(type: any='add',row:any) {
  //   console.log('row',row)
  //   this.restForm();
  //   this.operateType = type
  //   this.getDepartmentList()
  //   // this.visible = true;
  //   if(this.operateType === 'edit'){
  //     this.forms = row;
  //   }
  // }
  // private deluser(id: string): void {
  //   this.operationRecordApi.deluser(
  //       {
  //         id: id,
  //       },
  //       () => {
  //         Util.showToast("删除成功");
  //         this.getTable();
  //       }
  //   );
  // }

  // private submit(): void {
  //   if (this.operateType == "add") {
  //     this.operationRecordApi.membersadd(this.forms, () => {
  //       this.visible = false;
  //       Util.showToast("新增账号成功");
  //       this.getTable();
  //     });
  //   } else {
  //     this.operationRecordApi.edituser(this.forms, () => {
  //       this.visible = false;
  //       Util.showToast("修改成功");
  //       this.search();
  //     });
  //   }
  // }

  private restForm(): void {
    this.form = this.deepLoopUtil.deepCopy(defaultForm);
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }


}
